import React from "react";
import Forecast5 from "./Forecast5";

class Weather extends React.Component {
	componentDidMount() {}

	render() {
		return (
			<div>
				<Forecast5 />
			</div>
		);
	}
}

export default Weather;



// WEBPACK FOOTER //
// ./src/components/Weather.js